module.exports = __webpack_public_path__ + "image-f2b2cf512cab.png";